module.exports = __webpack_public_path__ + "static/img/mainNews.ab23362.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/sportsLogo/mainNews.png
// module id = L3x2
// module chunks = 9